import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import HelpButton from 'help/HelpButton';
import getTestProps from 'test/lib/cypress/getTestProps';
import {InputChangeEvent} from 'util/Types';

import * as SpreadsheetBulkImportActions from './SpreadsheetBulkImportActions';

interface SpreadsheetBulkImportOptionProps {
  className?: string;
  helpContent?: JSX.Element;
  isChecked: boolean;
  isDisabled?: boolean;
  name: string;
  // Optional onChange callback to set dependent data
  onChange?: (e: InputChangeEvent) => void;
  text: React.ReactNode;
}

export default function SpreadsheetBulkImportOption({
  className,
  helpContent,
  isChecked,
  isDisabled = false,
  name,
  onChange,
  text,
}: SpreadsheetBulkImportOptionProps): JSX.Element {
  const handleChangeOption = (e: InputChangeEvent): void => {
    // If onChange is specified, allow caller to handle change.
    if (onChange) {
      onChange(e);
      return;
    }
    // Otherwise, default to updating option in store.
    SpreadsheetBulkImportActions.setOptions({[name]: e.target.checked});
  };

  return (
    <div
      className={classNames(className, css(styles.optionDiv))}
      {...getTestProps({component: 'SpreadsheetBulkImportOption', element: 'root', key: name})}
      data-amp-safe={false}
    >
      <label className={classNames('u-normal-font-weight', css(styles.optionLabel), {'u-faded': isDisabled})}>
        <input
          type="checkbox"
          disabled={isDisabled}
          onChange={handleChangeOption}
          checked={isChecked}
          {...getTestProps({component: 'SpreadsheetBulkImportOption', element: 'checkbox', key: name})}
          data-amp-safe={false}
        />
        {text}
      </label>
      {helpContent && (
        <span>
          <HelpButton renderContent={() => helpContent} iconClassName="u-tiny-spacing-left" />
        </span>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  optionDiv: {
    display: 'flex',
  },
  optionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
});
